import { useState } from 'react';
import { useForm } from '../../hooks/useForm';

import ErrorMessage from './ErrorMessage';
import SubmitButton from './SubmitButton';
import SuccessMessage from './SuccessMessage';
import TextInput from './TextInput';

const NewsletterForm = ({ title, titleSize, buttonText }) => {
    const TitleTag = `h${titleSize}`;
    const [apiError, setApiError] = useState(null);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting, isSubmitSuccessful }
    } = useForm({ defaultValues: { email: '' } });

    const onSubmit = async data => {
        setApiError(null);
        try {
            const res = await fetch('/api/forms/newsletter.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });

            const json = await res.json();

            if (!json.success) {
                throw new Error(json.message || 'Noe gikk galt, prøv igjen senere');
            }

            reset();
            return json;
        } catch (err) {
            setApiError(err.message);
            throw err;
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {title && <TitleTag>{title}</TitleTag>}

            <TextInput
                label="E-post*"
                name="email"
                type="email"
                autocomplete="email"
                error={errors.email}
                disableTab={isSubmitSuccessful}
                {...register('email', {
                    required: 'E-post er påkrevd.',
                    pattern: { value: /\S+@\S+\.\S+/, message: 'Ugyldig e-post.' }
                })}
            />

            <div className="form-submit-row">
                <SubmitButton isLoading={isSubmitting} disableTab={isSubmitSuccessful}>
                    {buttonText || 'Meld meg på'}
                </SubmitButton>
                {apiError && <ErrorMessage message={apiError} />}
                {isSubmitSuccessful && <SuccessMessage message="Takk for påmeldingen!" />}
            </div>
        </form>
    );
};
export default NewsletterForm;
